import React, { Component } from 'react';
import { ApiHelper } from '../helpers/ApiHelper';
import { StyleSheet, css } from 'aphrodite';
import { AppTheme } from '../../styles/AppTheme';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';

export class NextPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fetchState: ApiHelper.State.LOADING,
    }
  }

  render() {
    return (<div className={css(Styles.nextPageContainer)}>
      <Button
        variant="contained"
        color="primary"
        disabled={this.state.inProcess}
        onClick={this.props.onNext}
      >
        {'SHOW MORE'.toLocaleUpperCase()}
        {this.props.nextPageState === ApiHelper.State.LOADING && <CircularProgress size={20} className={css(Styles.progress)} />}
      </Button>
    </div>)
  }
}

const Styles = StyleSheet.create({
  nextPageContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 30,
  },
  progress: {
    marginLeft: 10,
    color: 'white'
  },
})


// WEBPACK FOOTER //
// ./src/common/components/NextPage.js